import {Modal, Spin} from "antd";
import React from "react";

export default function (props) {
    return <Modal title="Confirm Notification" visible={props.showSendDialog !== false}
                  onOk={props.onOk} onCancel={props.onCancel}>
        <Spin spinning={props.spinning}>
            <p>Are you sure you want to send a {props.showSendDialog} notification email to the new hire?</p>
        </Spin>
    </Modal>
}